<div class="">
 <div class="cross-btn" (click)="closePopup()">
     <!--  <i class="fas fa-times"></i> -->
     <img src="../../../../assets/icon/closex.svg" alt="" />
  </div>
  <!--border -->
  <div class="star-img">
    <img src="../../../assets/images/lucky_star_svg.svg" alt="">
  </div>

  <div class="unlock">
    <h6 class=" ">
      {{luckyNosDetails?._extract ? luckyNosDetails?._extract?.[languageCode] :luckyNosDetails?.extract}}
    </h6>
  </div>
  <div class="lucky-nos">
    <h6 class="">
      {{title}}
    </h6>
  </div>
  <div class="mark-lucky">
    <p>{{luckyNosDetails?._message_content ? luckyNosDetails?._message_content?.[languageCode] : luckyNosDetails?.message_content}}</p>
  </div>
  <div class="choose-btn">
    <button (click)="goToSyndicates()">
      {{luckyNosDetails?._button_label ? luckyNosDetails?._button_label?.[languageCode] : luckyNosDetails?.button_label}}
    </button>
  </div>
</div>